<template>
  <figure class="highcharts-figure">
    <highcharts ref="chart" :options="options" />
    <p class="highcharts-description highcharts-linked-description">
      <strong>Figure : </strong>
      {{ $t('compGraphicsPurchasesPieSecondHand.help') }}
    </p>
  </figure>
</template>

<script>
import '@/plugins/highcharts.js'

export default {
  name: 'PurchasesPieSecondHand',
  props: {
    ghgi: {
      type: Object,
      default: null
    }
  },
  computed: {
    series: function () {
      let series = [
        {
          name: this.$t('compGraphicsPurchasesPieSecondHand.other.purchases'),
          y: 0,
          uncertainty: 0
        }
      ]
      for (let category in this.ghgi.emissions.purchases.categories) {
        if (['lab.life', 'lab.equipment', 'info'].includes(category)) {
          series.push({
            name: this.$t(category),
            y: this.ghgi.emissions.purchases.categories[category].intensity,
            uncertainty:
              this.ghgi.emissions.purchases.categories[category].uncertainty
          })
        } else {
          series[0].y +=
            this.ghgi.emissions.purchases.categories[category].intensity
          series[0].uncertainty +=
            this.ghgi.emissions.purchases.categories[category].uncertainty
        }
      }
      return series
    },
    options: function () {
      let self = this
      return {
        chart: {
          type: 'pie'
        },
        title: {
          verticalAlign: 'middle',
          floating: true,
          text: `<b>${self.$options.filters.splitNumberTons(
            Math.round(self.ghgi.emissions.purchases.intensity.intensity)
          )} ${self.$t('t.co2e')} </b>`
        },
        plotOptions: {
          pie: {
            innerSize: '60%',
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              formatter () {
                return `<b>${
                  this.point.name
                }:</b> ${self.$options.filters.splitNumberTons(
                  this.y
                )} ${self.$t('t.co2e')}`
              }
            },
            showInLegend: true
          }
        },
        series: [
          {
            name: this.$t('carbon.footprint'),
            colorByPoint: true,
            data: this.series
          }
        ],
        legend: {
          enabled: false
        },
        tooltip: {
          formatter: function () {
            return `${this.key}<br/><b>${self.$options.filters.splitNumberTons(
              this.y
            )} ${self.$t('t.co2e')}</b>`
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.highcharts-figure {
  min-width: 320px;
  max-width: 700px;
  margin: 1em auto;
}
.highcharts-description {
  text-align: center;
  color: '#777777';
  font-style: italic;
}
</style>
